/* eslint-disable prefer-destructuring */
import MDBox from "components/Basics/MDBox";

/**
 * Message component to display a single message in a conversation.
 * @param {Object} message - The message object containing header and payload.
 * @return {JSX.Element} The rendered Message component.
 */
const Message = ({ message }) => {
	let styleDirection = {};

	let header = message.header;
	let payload = message.payload;

	if (header.source === "contact") {
		styleDirection = {
			left: 10,
			maxWidth: "80%",
			marginRight: "20%",
			backgroundColor: "white",
			borderRadius: "15px 15px 15px 0",
			padding: 10
		};
	} else if (["cockpit", "bot"].includes(header.source)) {
		styleDirection = {
			right: 10,
			maxWidth: "80%",
			marginLeft: "20%",
			backgroundColor: "#2196f3",
			color: "white",
			fontWeight: "bold",
			borderRadius: "15px 15px 0 15px",
			padding: 10
		};
	}

	return (
		<MDBox mt={1} style={styleDirection}>
			<p
				style={{
					fontSize: 12,
					whiteSpace: "pre-wrap"
				}}
			>
				{payload.text}
			</p>
		</MDBox>
	);
};

export default Message;
